import type { Dispatch } from 'redux';
import { createActionFactory, Feature, ThunkDispatch } from '../../../shared';
import { exportContacts } from '../../actions/data/exportContactsDataActions';

export const exportContactsDismissedAction = createActionFactory<void>(
    'ExportContactsDismissedAction',
    Feature.ExportContacts
);
export const exportContactsClickedAction = createActionFactory<void>(
    'ExportContactsClickedAction',
    Feature.ExportContacts
);

export const exportContactsDismissed = (dispatch: Dispatch) => () =>
    dispatch(exportContactsDismissedAction());
export const startExportingContacts = (dispatch: ThunkDispatch) => (
    fileName: string,
    folderId?: string
) => {
    dispatch(exportContactsClickedAction());
    dispatch(exportContacts(fileName, folderId));
};
export type { Action } from '../../../shared';
